import { Component } from 'vue-property-decorator';
import Vue from 'vue';
import BpcContactTable from '@contacts/components/tables/contact-table/contact-table.vue';
import { CenterSetting } from '@core/interfaces/center-setting';

@Component({
  name: 'bpc-contacts-tppwb',
  components: {
    'bpc-contact-table': BpcContactTable,
  },
})
export default class Contacts extends Vue {
  /* Lifecycle hooks */
  // created() { }
  // mounted() {}
  // updated () { }
  // destroyed () { }

  get fetchPath() {
    const url = this.$bpcApiRouteHelper.getEntityPath('contact');
    return `${url}/tppwb`;
  }

  get displayConfigName() {
    if (
      this.centerSetting.tppwb_sync_padel_activated &&
      this.centerSetting.tppwb_sync_tennis_activated
    ) {
      return 'table-for-tppwb';
    } else if (
      this.centerSetting.tppwb_sync_padel_activated &&
      !this.centerSetting.tppwb_sync_tennis_activated
    ) {
      return 'table-for-tppwb-padel';
    } else if (
      !this.centerSetting.tppwb_sync_padel_activated &&
      this.centerSetting.tppwb_sync_tennis_activated
    ) {
      return 'table-for-tppwb-tennis';
    } else {
      return 'table-for-tppwb-no-disciplines';
    }
  }
  get filterConfigName() {
    if (
      this.centerSetting.tppwb_sync_padel_activated &&
      this.centerSetting.tppwb_sync_tennis_activated
    ) {
      return 'tabs-tppwb';
    } else if (
      this.centerSetting.tppwb_sync_padel_activated &&
      !this.centerSetting.tppwb_sync_tennis_activated
    ) {
      return 'tabs-tppwb-padel';
    } else if (
      !this.centerSetting.tppwb_sync_padel_activated &&
      this.centerSetting.tppwb_sync_tennis_activated
    ) {
      return 'tabs-tppwb-tennis';
    }
  }

  get centerSetting(): CenterSetting {
    return this.$store.getters['centerSettings/centerSettings'];
  }
}
